<template>
<!-- 経費エラーメッセージ -->
<div>
  <p style="color: red;" v-for="error in dayEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in typeEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in originEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in destinationEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in routeEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in costEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in costRegex" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in remarksEmpty" :key="error">{{ '※' + error }}</p>
</div>
</template>

<script>
import ConstList from './../../ConstList'
export default {
  name: 'ExpenseError',
  data() {
    return {
      dayEmpty: [],
      typeEmpty: [],
      originEmpty: [],
      destinationEmpty: [],
      routeEmpty: [],
      costEmpty: [],
      costRegex: [],
      remarksEmpty: []
    }
  },
  props: {
    day1: Array,
    request_type: Array,
    origin: Array,
    destination: Array,
    route: Array,
    cost: Array,
    remarks: Array
  },
  methods: {
    // 日付の空文字チェック
    day1_empty: function () {
      let error = this.dayEmpty
      const day = this.day1
      const type = this.request_type
      const origin = this.origin
      const destination = this.destination
      const route = this.route
      const cost = this.cost
      const remarks = this.remarks
      day.forEach((value, i, array) => {
        if (((type[i] !== "") || (origin[i] !== "") || (destination[i] !== "") || (cost[i] !== "") || (route[i] !== "") || (remarks[i] !== "")) && (array[i] === "")) {
          error.splice(i, 1, i + 1 + '行目の日付を選択してください ')
          let set = Array.from(new Set(error))
          error = set
        } else {
          error.splice(i, 1)
        }
      })
    },
    // 申請区分の空文字チェック
    type_empty: function () {
      let error = this.typeEmpty
      const day = this.day1
      const type = this.request_type
      const origin = this.origin
      const destination = this.destination
      const route = this.route
      const cost = this.cost
      const remarks = this.remarks
      type.forEach((value, i, array) => {
        if (((day[i] !== "") || (origin[i] !== "") || (destination[i] !== "") || (route[i] !== "") || (cost[i] !== "") || (remarks[i] !== "")) && (array[i] === "")) {
          error.splice(i, 1, i + 1 + '行目の申請区分を選択してください ')
          let set = Array.from(new Set(error))
          error = set
        } else {
          error.splice(i, 1)
        }
      })
    },
    // 発地の空文字チェック
    origin_empty: function () {
      let error = this.originEmpty
      const type = this.request_type
      const origin = this.origin
      const destination = this.destination
      origin.forEach((value, i, array) => {
        if (((type[i] === ConstList.TRANSPORT_ID) || (destination[i] !== "")) && (array[i] === "")) {
          error.splice(i, 1, i + 1 + '行目の出発を入力してください ')
          let set = Array.from(new Set(error))
          error = set
        } else {
          error.splice(i, 1)
        }
      })
    },
    // 着地の空文字チェック
    destination_empty: function () {
      let error = this.destinationEmpty
      const type = this.request_type
      const origin = this.origin
      const destination = this.destination
      destination.forEach((value, i, array) => {
        if (((type[i] === ConstList.TRANSPORT_ID) || (origin[i] !== "")) && (array[i] === "")) {
          error.splice(i, 1, i + 1 + '行目の到着を入力してください ')
          let set = Array.from(new Set(error))
          error = set
        } else {
          error.splice(i, 1)
        }
      })
    },
    // 便名・種別・地名等の空文字チェック
    route_empty: function () {
      let error = this.routeEmpty
      const type = this.request_type
      const route = this.route
      route.forEach((value, i, array) => {
        if (((type[i] === ConstList.TRANSPORT_ID) || (type[i] === ConstList.STAY_ID)) && (array[i] === "")) {
          error.splice(i, 1, i + 1 + '行目の便名・種別・地名等を入力してください ')
          let set = Array.from(new Set(error))
          error = set
        } else {
          error.splice(i, 1)
        }
      })
    },
    // 金額の空文字チェック
    cost_empty: function () {
      let error = this.costEmpty
      const day = this.day1
      const type = this.request_type
      const origin = this.origin
      const destination = this.destination
      const route = this.route
      const cost = this.cost
      const remarks = this.remarks
      cost.forEach((value, i, array) => {
        if (((day[i] !== "") || (type[i] !== "") || (origin[i] !== "") || (destination[i] !== "") || (route[i] !== "") || (remarks[i] !== "")) && (array[i] === "")) {
          error.splice(i, 1, i + 1 + '行目の金額を入力してください ')
          let set = Array.from(new Set(error))
          error = set
        } else {
          error.splice(i, 1)
        }
      })
    },
    // 金額の入力形式チェック
    cost_regex: function () {
      let error = this.costRegex
      const cost = this.cost
      cost.forEach((value, i) => {
        if ((value !== "") && ((!value.match(/^\d{1,3},\d{3}$/)) && (!value.match(/^\d{1,3}$/)))) {
          error.splice(i, 1, i + 1 + '行目の金額は半角数字のみを用いて入力してください')
          let set = Array.from(new Set(error))
          error = set
        } else {
          error.splice(i, 1)
        }
      })
    },
    // 備考の空文字チェック
    remarks_empty: function () {
      let error = this.remarksEmpty
      const day = this.day1
      const type = this.request_type
      const origin = this.origin
      const destination = this.destination
      const route = this.route
      const cost = this.cost
      const remarks = this.remarks
      remarks.forEach((value, i, array) => {
        if (((day[i] !== "") || (type[i] !== "") || (origin[i] !== "") || (destination[i] !== "") || (route[i] !== "") || (cost[i] !== "")) && (array[i] === "")) {
          error.splice(i, 1, i + 1 + '行目の備考を入力してください ')
          let set = Array.from(new Set(error))
          error = set
        } else {
          error.splice(i, 1)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
